import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString } from '@/utils'

export default {
  async fetch(
      token,
      tenantIds= [],
      search = '',
      page = 1,
      limit = 4,
  ) {
    try {
      axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/instances';
      return await axios.get('', {
        params: {
          search: search,
          tenant_ids: tenantIds,
          pagination_page: page,
          pagination_limit: limit
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
    } catch (e) {
      console.error(e);
      return [];
    }
  },
  add(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createInstance (
            name: "${instance.name}",
            hub_host: "${instance.hub_host}"
          ) {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            qr_code,
            phone_number
          }
        }
      `
    })
  },
  update(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateInstance (
            id: ${instance.id},
            name: "${instance.name}",
            hub_host: "${instance.hub_host}"
          ) {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            qr_code,
            phone_number
          }
        }
      `
    })
  },
  updatePhoneNumber(instance) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateInstance (
            id: ${instance.id},
            phone_number: "${instance.phone_number}"
          ) {
            id,
            name,
            hub_host,
            activated,
            browser_session,
            qr_code,
            phone_number
          }
        }
      `
    })
  },
  delete(instanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteInstance (
            id: ${instanceId}
          )
        }
      `
    })
  }
}
